var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m23.18 6.71-2.1-.9 1.1-2.4-2.56.85a4.47 4.47 0 0 0-3-1.2 4.51 4.51 0 0 0-4.5 4.5v1c-3.54.73-6.63-1.2-9.5-4.5q-.75 4 1.5 6l-3.29-.5a4.55 4.55 0 0 0 4.25 4l-2.75 1c1 2 2.82 2.31 5.25 2.5a11.52 11.52 0 0 1-6.75 2c12.76 5.67 20.25-2.66 20.25-10v-.83z",
  clipRule: "evenodd"
})));
export default SvgTwitter;